// utils/cdnHost.js
//
// The photo host (collector-app P2-C, locked answers L-F and L-G): where the
// pictures of a line live (`https://media.poolit.club/media-gallery/<id>-s.jpg`).
// ONE place for the name — the service worker (src/sw.js, which imports this
// file, so it must stay free of Vue and of DOM globals) and the collector's
// morning download both read it, so the route that caches a photo and the code
// that asks for it can never disagree about which host that is.
//
// The host must answer `Access-Control-Allow-Origin` (owner action 1 of the
// phase-2 pack). Without it a CORS request fails loudly and nothing is cached.

export const CDN_ORIGIN = 'https://media.poolit.club';

/** True when `value` (a URL string or a URL) points at the photo host. */
export function isCdnUrl(value) {
  if (value == null) return false;
  try {
    return new URL(String(value)).origin === CDN_ORIGIN;
  } catch {
    return false;
  }
}
